import { FormlyFieldConfigMap } from './formly-field-config.map';
import {ConsumerType} from '@emm/core/models/consumer-type.model';

const consumerTypesPlaceHolder = 'Search for a Consumer Type';

export const consumerTypesFilterFieldMap: FormlyFieldConfigMap<ConsumerType> = {

    name: () => ({
        key: 'name',
        templateOptions: {
            label: 'Name',
            maxLength: 512,
            placeholder: consumerTypesPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    tag: () => ({
        key: 'tag',
        templateOptions: {
            label: 'Tag',
            maxLength: 512,
            placeholder: consumerTypesPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    })

};
